<template>
  <v-container grid-list-xs>
    <v-row>
      <v-col v-if="fetchingData">
        <v-icon>fas fa-spinner fa-spin</v-icon> carregando links...
      </v-col>
      <v-col v-if="!fetchingData" class="pa-0 text-center" cols="12">
        <template>
          <v-card>
            <v-card-title>
              <v-btn
                :disabled="fetchingData"
                color="green"
                class="mr-3"
                @click="openNewLink"
                ><v-icon small class="pr-2">fas fa-plus</v-icon> Novo
                link</v-btn
              >
              <v-text-field
                v-model="search"
                append-icon="fas fa-search"
                label="Pesquisa"
                single-line
                clearable
                hide-details
              ></v-text-field>
              <v-btn
                :disabled="fetchingData"
                color="primary"
                class="ml-3"
                @click="fetchLinks"
                ><v-icon small class="pr-2">fas fa-sync</v-icon>
                Recarregar</v-btn
              >
            </v-card-title>
            <v-data-table
              dense
              :headers="linkHeaders"
              :items="links"
              :search="search"
              :items-per-page="20"
              :footer-props="{
                itemsPerPageOptions: [10, 20, 50, -1]
              }"
            >
              <template v-slot:[`item.link`]="{ item }">
                <a :href="`https://omylinkgenerator.tk/api/r/${item.slug}`" target="_blanc">{{`https://omylinkgenerator.tk/api/r/${item.slug}`}}</a>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      color="primary"
                      icon
                      @click="openEditLink(item)"
                    >
                      <v-icon>fas fa-pen</v-icon></v-btn
                    >
                  </template>
                  <span>Editar link</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      color="red"
                      icon
                      @click="deleteLink(item)"
                    >
                      <v-icon>fas fa-times</v-icon></v-btn
                    >
                  </template>
                  <span>Excluir link</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </template>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogs.newLink" scrollable max-width="800">
      <v-card>
        <v-card-title class="headline">Novo link</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="newLink.slug"
                label="Nome (slug)"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="newLink.fake"
                label="Fake link"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="newLink.real"
                label="Link verdadeiro"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="newLink.crawlers"
                label="Crawlers para serem ignorados"
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="fetchingData"
            color="green darken-1"
            text
            @click="createNewLink()"
          >
            Criar
          </v-btn>
          <v-btn
            :disabled="fetchingData"
            color="blue darken-1"
            text
            @click="dialogs.newLink = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogs.editLink" scrollable max-width="800">
      <v-card>
        <v-card-title class="headline">Editar link</v-card-title>
        <v-card-text>
          <v-row v-if="editLink">
            <v-col cols="6">
              <v-text-field
                v-model="editLink.slug"
                label="Nome (slug)"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editLink.fake"
                label="Fake link"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editLink.real"
                label="Link verdadeiro"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editLink.crawlers"
                label="Crawlers para serem ignorados"
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="fetchingData"
            color="green darken-1"
            text
            @click="updateLink()"
          >
            Salvar
          </v-btn>
          <v-btn
            :disabled="fetchingData"
            color="blue darken-1"
            text
            @click="dialogs.newLink = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: 'home',
  components: {},
  data() {
    return {
      fetchingData: false,
      links: [],
      linkHeaders: [
        { text: 'LINK', value: 'link', align: 'left' },
        { text: 'Nome', value: 'slug', align: 'left' },
        { text: 'Fake', value: 'fake', align: 'left' },
        { text: 'Verdadeiro', value: 'real', align: 'left' },
        { text: 'Crawlers', value: 'crawlers', align: 'left' },
        { text: 'Ações', value: 'actions', align: 'right' }
      ],
      newLink: {},
      editLink: null,
      search: null,
      dialogs: {
        newLink: false
      }
    }
  },
  mounted() {},
  created() {
    this.fetchLinks()
  },
  methods: {
    fetchLinks() {
      var vm = this
      vm.fetchingData = true
      return new Promise((resolve, reject) => {
        vm.$API
          .Request('GET', 'link/list', {})
          .then(result => {
            if (result && result.data) {
              vm.links = result.data
            } else {
              vm.$snotify.warning('Nenhuma informação encontrada')
            }
            vm.fetchingData = false
            vm.dialogs.newLink = false
            resolve(true)
          })
          .catch(error => {
            vm.$snotify.error(error.message)
            vm.fetchingData = false
            vm.dialogs.newLink = false
            reject(error)
          })
      })
    },
    openNewLink() {
      var vm = this
      vm.newLink = {
        slug: null,
        fake: 'https://',
        real: 'https://',
        crawlers: 'facebookexternalhit'
      }
      vm.dialogs.newLink = true
    },
    openEditLink(link) {
      var vm = this
      vm.editLink = link
      vm.dialogs.editLink = true
    },
    deleteLink(link) {
      var vm = this
      vm.$confirm(`Você realmente deseja excluir este link?`, {
        title: 'Atenção',
        buttonTrueText: 'Sim',
        buttonFalseText: 'Não',
        persistent: true
      }).then(res => {
        if (res) {
          vm.fetchingData = true
          return new Promise((resolve, reject) => {
            vm.$API
              .Request('DELETE', `link/delete/${link.id}`)
              .then(() => {
                vm.$snotify.warning('Link removido com sucesso')
                vm.fetchLinks()
                resolve(true)
              })
              .catch(error => {
                vm.$snotify.error(error.message)
                vm.fetchingData = false
                reject(error)
              })
          })
        }
      })
    },
    createNewLink() {
      var vm = this
      if (vm.newLink && vm.newLink.slug && vm.newLink.slug.length > 0) {
        vm.$API
          .Request('POST', 'link/create', vm.newLink)
          .then(result => {
            if (result && result.data) {
              vm.$snotify.success('Novo link criado com sucesso!')
            } else {
              vm.$snotify.warning('não foi possível criar um novo link')
            }
            vm.fetchLinks()
          })
          .catch(error => {
            vm.$snotify.error(error.message)
            vm.fetchingData = false
          })
      } else {
        vm.$snotify.error('Não é possível criar um link sem um slug')
      }
    },
    updateLink() {
      var vm = this
      if (vm.newLink && vm.editLink.slug && vm.editLink.slug.length > 0) {
        vm.$API
          .Request('POST', `link/update/${vm.editLink.id}`, vm.editLink)
          .then(() => {
            vm.$snotify.success('Link editado com sucesso!')
            vm.dialogs.editLink = false
            vm.editLink = null
            vm.fetchLinks()
          })
          .catch(error => {
            vm.$snotify.error(error.message)
            vm.fetchingData = false
            vm.dialogs.editLink = false
          })
      } else {
        vm.$snotify.error('Não é possível editar um link sem um slug')
      }
    }
  }
}
</script>
